import { inject, Service, signal } from '@angular/core';
import { WebSocketActionEnum } from '@shared/enums/websocket';
import { EquipmentCommand } from '../realtime/equipment-command';

@Service()
export class Recovery {
  private readonly equipmentCommands = inject(EquipmentCommand);

  private readonly recoverable = signal(false);
  readonly canRecover = this.recoverable.asReadonly();

  setCanRecover(value: boolean): void {
    this.recoverable.set(value);
  }

  sendRecoverMessage(sourceId: string, destinationId: string | null, recover: boolean) {
    void this.equipmentCommands.sendOutsideLive(WebSocketActionEnum.RECOVER, { Recover: recover }, { sourceId, equipmentId: destinationId });
  }

  sendCanRecoverMessage(sourceId: string, destinationId: string | null, canRecover: boolean) {
    void this.equipmentCommands.sendOutsideLive(WebSocketActionEnum.RECOVER, { CanRecover: canRecover }, { sourceId, equipmentId: destinationId });
  }
}
